<template>
  <div>
    <component
      :is="questionComponent"
      v-if="task.content.component"
      ref="question"
      v-bind="$attrs"
      :task="task"
      :task-state="taskState"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import RemovedTask from '@/tasks/components/RemovedTask.vue';

export default {
  name: 'DynamicQuestion',
  inheritAttrs: false,
  props: ['task', 'taskState'],
  computed: {
    isLoaded() {
      return this.task.taskStates.length === 0 || this.taskState !== null;
    },
    questionComponent() {
      const {component, questionId} = this.task.content;

      return () => ({
        component: import(`./dynamic-questions/${component || questionId}.vue`),
        // Show RemovedTask only when the import actually rejects (the component
        // was removed). We intentionally omit `timeout`: it doesn't detect
        // removals (rejection does that immediately) and only causes slow but
        // valid loads on poor networks to be shown as "removed" incorrectly.
        error: RemovedTask,
        delay: 0,
      });
    },
  },
  methods: {
    submitResponse() {
      this.$refs.question.submitResponse();
    },
    setResponse(...args) {
      const question = this.$refs.question;
      if (question) {
        // The async question component may have resolved to a component that
        // does not implement setResponse (e.g. RemovedTask, or a task type that
        // is only rendered by the Inertia front-end). Guard against calling a
        // method that isn't there rather than throwing (LEGACY-FRONTEND-T1).
        if (typeof question.setResponse === 'function') {
          question.setResponse(...args);
        }
      } else {
        // FIXME: Hack - the async question component hasn't resolved yet, retry.
        setTimeout(() => {
          this.setResponse(...args);
        }, 500);
      }
    },
    clearResponse(...args) {
      const question = this.$refs.question;
      if (question) {
        if (typeof question.clearResponse === 'function') {
          question.clearResponse(...args);
        }
      } else {
        // FIXME: Hack - the async question component hasn't resolved yet, retry.
        setTimeout(() => {
          this.clearResponse(...args);
        }, 500);
      }
    },
  },
};
</script>
